// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

// Images
import supportImage from "assets/images/tech-support1.png"; 
import wavesWhite from "assets/images/shapes/waves-white.svg";

/* eslint-disable react/prop-types */

function SupportDetails({data}) {
  return (
    <SoftBox
      position="relative"
      bgColor="dark"
      py={3}
      px={{ xs: 3, sm: 6 }}
      mt={3}
      borderRadius="xl"
      variant="gradient"
    >
      <SoftBox
        component="img"
        src={wavesWhite}
        alt="desen"
        width="100%"
        position="absolute"
        left="0"
        top="0"
        opacity={0.4}
      />
      <Grid container alignItems="center" position="relative">
        <Grid item xs={12} lg={3}>
          <SoftBox px={{ xs: 0, md: 1.5 }}>
            <SoftTypography variant="h4" color="white" textTransform="capitalize" opacity={0.9}>
              Son Destek Talebi
            </SoftTypography>
            <Divider light />
            <SoftBox display="flex">
              <SoftBox>
                <SoftTypography variant="h6" color="white" textTransform="capitalize" opacity={0.7}>
                  Durum
                </SoftTypography>
                <SoftTypography variant="h3" fontWeight="bold" color="white">
                  Açık
                </SoftTypography>
              </SoftBox>
              <SoftBox ml={{ xs: 3, md: 8 }} mb={{ xs: 1, md: 0 }}>
                <SoftTypography variant="h6" color="white" textTransform="capitalize" opacity={0.7}>
                  Ortalama Yanıt Süresi
                </SoftTypography>
                <SoftTypography variant="h3" fontWeight="bold" color="white">
                  1-2{" "}
                  <SoftTypography variant="button" color="white" verticalAlign="top">
                    Saat
                  </SoftTypography>
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Grid>
        <Grid item xs={12} lg={6}>
          <SoftBox textAlign="center">
            <SoftBox
              component="img"
              src={supportImage}
              alt="destek resmi"
              display={{ xs: "none", md: "block" }}
              width="-webkit-fill-available"
              mt={{ xs: 0, lg: -16 }}
            />
            <SoftBox
              display="flex"
              justifyContent={{ xs: "flex-start", md: "center" }}
              alignItems="center"
              mb={1}
            >
              <SoftTypography variant="h4" color="white" textTransform="capitalize" opacity={0.7}>
                Mevcut Destek Durumu
              </SoftTypography>
              <SoftBox ml={1}>
                <SoftTypography variant="h2" fontWeight="bold" color="white">
                  %{data?.ozet_bilgiler?.toplam_ticket_sayisi > 0 ? Math.floor((data?.ozet_bilgiler?.toplam_ticket_sayisi - data?.ozet_bilgiler?.acik_ticket_sayisi) / data?.ozet_bilgiler?.toplam_ticket_sayisi * 100) : 100}
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Grid>
        <Grid item xs={12} lg={3}>
          <SoftBox px={{ xs: 0, md: 1.5 }}>
            <SoftTypography variant="h4" color="white" textTransform="capitalize" opacity={0.9}>
              En Yakın Çözüm Merkezi
            </SoftTypography>
            <Divider light />
            <SoftBox display="flex">
              <SoftBox>
                <SoftTypography variant="h6" color="white">
                Adnan Saygun Cad. TRT, 
                </SoftTypography>
                <SoftTypography variant="h6" color="white">
                 Ulus/İstanbul
                </SoftTypography>
              </SoftBox>
              <SoftBox ml={8}>
                <SoftButton variant="outlined" circular iconOnly>
                  <Icon>map</Icon>
                </SoftButton>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Grid>
      </Grid>
    </SoftBox>
  );
}

export default SupportDetails;
